import { render, staticRenderFns } from "./evaluationsTable.vue?vue&type=template&id=4374ccd4"
import script from "./evaluationsTable.vue?vue&type=script&lang=js"
export * from "./evaluationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports